<template lang="pug">
  v-container
    new-product-dialog(v-model="dialog")
    v-card
      v-card-title
        | Products List
        .flex-grow-1
        v-text-field.mt-n4(v-model='search' append-icon='mdi-magnify' label='Search' single-line hide-details fixed-header @keyup.enter="fetchProduct()" clearable)
        v-tooltip(bottom)
          template(v-slot:activator="{ on }")
            v-btn.ml-4(icon v-on="on" @click="dialog = true")
              v-icon mdi-briefcase-plus-outline
          span Add Product
      //h4.ml-4 Draft Products
      v-data-table(:headers='headers' :items='products' :options.sync="options" :server-items-length="totalProducts" disable-sort)
        template(v-slot:item.vertical='{ item }') {{ item.vertical | verticalView }}
        template(v-slot:item.provider='{ item }') {{ item.provider | providerView }}
        //- template(v-if="this.$store.state.groups.includes('Production')" v-slot:item.phase='{ item }') {{ item.phase }}
        //- template(v-if="this.$store.state.groups.includes('Marketing')" v-slot:item.status='{ item }') {{ item.status }}
        template(v-slot:item.action='{ item }')
          v-btn.mr-2(icon)
            v-icon(small @click='editItem(item.id)') mdi-pencil
          v-icon(small @click='deleteItem(item)') mdi-delete
      //h4.ml-4.mt-4 Final Products
      //v-data-table(:headers='headers' :items='products' :options.sync="options" :server-items-length="totalProducts" disable-sort)
        template(v-slot:item.vertical='{ item }') {{ item.vertical | verticalView }}
        template(v-slot:item.provider='{ item }') {{ item.provider | providerView }}
        //- template(v-if="this.$store.state.groups.includes('Production')" v-slot:item.phase='{ item }') {{ item.phase }}
        //- template(v-if="this.$store.state.groups.includes('Marketing')" v-slot:item.status='{ item }') {{ item.status }}
        template(v-slot:item.action='{ item }')
          v-btn.mr-2(icon)
            v-icon(small @click='editItem(item.id)') mdi-pencil
          v-icon(small @click='deleteItem(item)') mdi-delete
</template>

<script>
import NewProductDialog from '@/components/NewProductDialog'

export default {
  name: 'Product',
  components: { NewProductDialog },
  data: vm => ({
    dialog: false,
    search: '',
    options: {},
    headers: [
      { text: 'ID', value: 'id' },
      { text: 'Vertical', value: 'vertical' },
      { text: 'Providers', value: 'provider_list', width: '12%' },
      { text: 'Name', value: 'original_title', width: '45%' },
      { text: 'City', value: 'city.name' },
      { text: vm.$store.state.groups.includes('Production') ? 'Phase' : 'Status', value: vm.$store.state.groups.includes('Production') ? 'phase' : 'status' },
      // { text: 'Status', value: 'status' },
      { text: 'Action', value: 'action', sortable: false, width: '10%', align: 'center' }
    ],
    products: [],
    totalProducts: 0
  }),
  watch: {
    options: {
      handler () {
        // console.log(this.options)
        this.fetchProduct(this.options.page, this.options.itemsPerPage)
      },
      deep: true
    }
  },
  mounted () {
    this.fetchProduct()
  },
  methods: {
    fetchProduct (page = 1, itemsPerPage = 10) {
      this.$axios.get(`/products/?ordering=-id&page=${page}&page_size=${itemsPerPage}&phase=${this.$store.state.groups.includes('Production') ? '' : 'final'}&search=${this.search}`)
        .then(resp => {
          this.products = [...resp.data.results]
          this.totalProducts = resp.data.count
        })
    },
    editItem (item) {
      this.$router.push({ name: 'productID', params: { productID: item } })
    },
    deleteItem (item) {
      const index = this.desserts.indexOf(item)
      confirm('Are you sure you want to delete this product?') && this.desserts.splice(index, 1)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>